import Link from 'next/link';

import { ICasino } from 'constants/types';

import styles from './styles.module.css';
import { RTPI_UTM } from 'constants/routes';
import { Anchor } from 'constants/anchors';

const RowContainer = ({
  isLink,
  children,
  href = '',
}: React.PropsWithChildren<{
  href?: string;
  isLink?: boolean;
}>) => {
  if (isLink) {
    return (
      <Link className={styles.wrapper__link} href={href} target="_blank">
        {children}
      </Link>
    );
  }

  return <>{children}</>;
};

export const CasinoRow = ({
  gap,
  name,
  value,
  title,
  isLink,
}: {
  value?: any;
  name: string;
  gap?: string;
  title?: string;
  isLink?: boolean;
}) => {
  if (Array.isArray(value)) {
    return (
      <div className={styles.casino_details__detail}>
        <div className={styles.casino_details__detail_name}>{name}</div>
        <div className={styles.casino_details__detail_description}>
          <ul
            className={styles.casino_details__detail_description_list}
            style={{ gap: `${gap}px` }}
          >
            {value?.map((item, index) => (
              <li key={index}>
                {item}
                {index < value.length - 1 && ','}
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }

  return (
    <RowContainer isLink={isLink} href={value ?? title}>
      <div className={styles.casino_details__detail}>
        <div className={styles.casino_details__detail_name}>{name}</div>
        <div className={styles.casino_details__detail_description}>
          {title ?? value}
        </div>
      </div>
    </RowContainer>
  );
};

export const TabelDescription = ({ data }: { data: ICasino }) => {
  return (
    <section id="Info" className={styles.casino_details}>
      <div id={Anchor.CasinoDetails} className={styles.container_s}>
        <h2
          className={styles.casino_details__title}
        >{`${data?.name} ${'details'}`}</h2>
        <div className={styles.casino_details__wrapper}>
          <CasinoRow name="Casino" value={data?.name} />
          {(data.website || data?.link_play) && (
            <CasinoRow
              isLink
              name="Website"
              value={data?.link_play ?? `${data?.website}${RTPI_UTM}`}
              title={data?.website}
            />
          )}
          <CasinoRow name="Established" value={data.established} />
          <CasinoRow name="License" value={data.licenses} />
          <CasinoRow name="Software" value={data.software} gap="5" />
          <CasinoRow name="Compatibility" value={data.os} gap="5" />
          <CasinoRow name="Deposits" value={data.payments} />
          <CasinoRow name="Languages" value={data.languages} />
          <CasinoRow name="Support" value={data.support} />
          <CasinoRow name="Currencies" value={data.currencies} />
        </div>
      </div>
    </section>
  );
};
